(function (window) {
  window.__env = window.__env || {};
  // The code format is essential since the environment will be replaced (webserver.js)!
  window.__env.appEnvironment = 'development';
}(this));
